import axiosInstance from './axiosInstance';
import { dateToTimestamp } from '@utils/date';

const pdfService = {
  /**
   * Generate PDF URL for a single document
   */
  async generatePdfUrl(documentData, selectedPageSize, selectedPageType, options = {}) {
    const {
      endpoint = 'facturas',
      usePreviewId = false,
      previewId = null,
      useDateTimestamp = false,
      dateField = 'date_time',
      idempresa
    } = options;

    const baseApiUrl = `/${endpoint}`;
    const pdfEndpoint = selectedPageSize === 'a4' ? 'pdf.php' : 'receipt.php';
    
    // Build query parameters
    const params = new URLSearchParams();
    params.append('idempresa', idempresa);
    
    if (documentData.type) params.append('type', documentData.type);
    if (documentData.posto) params.append('posto', documentData.posto);
    if (documentData.tpv) params.append('tpv', documentData.tpv);
    if (documentData.serie) params.append('serie', documentData.serie);
    if (documentData.numero) params.append('numero', documentData.numero);
    if (selectedPageType) params.append('page_type', selectedPageType);
    
    // Handle date field (can be date_time or custom)
    if (documentData[dateField] !== undefined) {
      const dateValue = useDateTimestamp ? dateToTimestamp(documentData[dateField]) : documentData[dateField];
      params.append(dateField, dateValue);
    }
    
    // Add preview ID if needed (for new documents)
    if (usePreviewId && previewId) {
      params.append('preview', previewId);
    }

    // Add bulk ID for bulk operations
    if (documentData.idbulk) {
      params.append('idbulk', documentData.idbulk);
    }

    // Return the full URL using axiosInstance baseURL
    const baseUrl = axiosInstance.defaults.baseURL;
    return `${baseUrl}${baseApiUrl}/${pdfEndpoint}?${params.toString()}`;
  },

  /**
   * Generate bulk PDF using the facturasService
   */
  async generateBulkPdf(idempresa, docs, selectedPageSize, selectedPageType) {
    try {
      // Import facturasService here to avoid circular dependencies
      const facturasService = (await import('./facturas')).default;
      
      const response = await facturasService.generateBulkPdf(idempresa, docs, selectedPageSize, selectedPageType);
      
      // Generate URL for the bulk PDF using the same logic as generatePdfUrl
      const baseUrl = axiosInstance.defaults.baseURL;
      const pdfEndpoint = selectedPageSize === 'a4' ? 'pdf.php' : 'receipt.php';
      const params = new URLSearchParams();
      params.append('idempresa', idempresa);
      params.append('idbulk', response.idbulk);
      
      const url = `${baseUrl}/facturas/${pdfEndpoint}?${params.toString()}`;
      
      return { idbulk: response.idbulk, url };
    } catch (error) {
      console.error('Erro ao gerar PDF em bulk:', error);
      throw error;
    }
  },

  /**
   * Check if a PDF endpoint is accessible
   */
  async validatePdfEndpoint(endpoint, idempresa) {
    try {
      const response = await axiosInstance.get(`/${endpoint}/pdf.php?idempresa=${idempresa}&validate=true`);
      return response.status === 200;
    } catch (error) {
      console.warn(`PDF endpoint validation failed for ${endpoint}:`, error);
      return false;
    }
  }
};

export default pdfService;
